import React from 'react';
import { createGlobalStyle as css } from 'styled-components';
import { useLocale } from './hooks/useLocale';

const CyrillicFonts = css`
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: normal;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: bold;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'spotify-circular-cyrillic';
    font-weight: 800;
    src: url('https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2')
      format('woff2');
    font-style: normal;
    font-display: swap;
  }
`;

export function I18nFonts() {
  const { locale } = useLocale();
  return <>{['ru', 'bg'].includes(locale) && <CyrillicFonts />}</>;
}
